<app-exceedance-compliance-filters
    mode="config"
    [values]="filterValues"
    (filterChange)="onFilterChange($event)">
</app-exceedance-compliance-filters>
